import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {blendColors} from '../../../../../libs/shared/core/src/models/helpers/colorHelpers';
import {disabledCss} from '../../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface BaseComposerToolbarProps {
  isTopBorderHidden?: boolean;
  isDisabled?: boolean;
  children: ReactNode;
}

/*
 * Style.
 */

const StyledToolbarDiv = styled.div<{$isDisabled: boolean | undefined}>`
  flex-shrink: 0;

  display: flex;
  padding: 10px 7px;

  background-color: ${(p) => p.theme.message.background};
  border-radius: 0 0 16px 16px;

  ${(p) => p.$isDisabled && disabledCss}
`;

const StyledToolbarBorderDiv = styled.div`
  border-top: 1px solid ${(p) => blendColors(p.theme.message.background, p.theme.message.border)};
`;

/*
 * Component.
 */

export const BaseComposerToolbar: FC<BaseComposerToolbarProps> = (props) => (
  <>
    {!props.isTopBorderHidden && <StyledToolbarBorderDiv />}
    <StyledToolbarDiv $isDisabled={props.isDisabled}>{props.children}</StyledToolbarDiv>
  </>
);
